<template>
    <div>
       <QueryFrame
            @handlePage="handlePage"
            @handlePageSize="handlePageSize"
            :current="page"
            :count="count"
            >
            <div slot=queryParams class="queryContainer">
                <div class="queryItem">
                    <label>门店名称:</label>
                    <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
                </div>
                <div class="queryItem">
                    <label>创建时间:</label>
                    <timeStampDatePicker
                        type='daterange'
                        placeholder='请选择'
                        v-model="query.createTimeRange"
                        :options="disabledDateFuture"
                        class="item"
                    ></timeStampDatePicker>
                </div>
                <div class="queryItem">
                    <label>盘点时间:</label>
                    <timeStampDatePicker
                        type='daterange'
                        placeholder='请选择'
                        v-model="query.operatorTimeRange"
                        class="item"
                    ></timeStampDatePicker>
                </div>
                <div class="queryItem">
                    <label>盘点状态:</label>
                    <lk-select class="item"  clearable v-model.trim="query.status" placeholder="请选择">
                        <lk-option v-for="(item, index) in statusList" :value="item[0]" :key="index">{{ item[1] }}
                        </lk-option>
                    </lk-select>
                </div>
                <div class="queryItem">
                    <label>盘点调整:</label>
                    <lk-select class="item"  clearable v-model.trim="query.adjustStatus" placeholder="请选择">
                        <lk-option v-for="item in adjustStatusList" :key="item.id" :value="item.id">
                        {{item.name}}
                        </lk-option>
                    </lk-select>
                </div>
                <div class="queryItem">
                    <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
                    <lk-button @click="handleReset">重置</lk-button>
                </div>
            </div>
            <div slot="table">
                <lk-table border :columns="columns" :data="tableData"></lk-table>
            </div>
        </QueryFrame>
    </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import mapState from '@/mixins/mapState';
import queryMixins from '@/mixins/queryMixins';
import inventoryManage from '@/services/inventoryManage';
import utils from '@/libs/utils';
import sharedData from '@/libs/sharedDara';


export default {
  name: 'inventoryeList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      disabledDateFuture: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      tableData: [],
      operatorTypeList: [], // 盘点类型
      operatorPatternsList: [], // 盘点方式
      query: {
        storeIdList: [],
        createTimeRange: null, // 创建时间
        operatorTimeRange: null, // 盘点时间
        status: null, // 盘点状态
        adjustStatus: null, // 盘点调整
      },
      adjustStatusList: [
        {
          id: 1,
          name: '未调整',
        },
        {
          id: 2,
          name: '全部调整',
        },
        {
          id: 3,
          name: '无需调整',
        },
      ], // 盘点调整进度
      statusList: new Map([
        [1, '盘点未开始'],
        [2, '初盘待完成'],
        [3, '初盘已完成'],
        [4, '复盘待完成'],
        [5, '已取消'],
        [6, '复盘已完成'],
        [7, '无需盘点'],
      ]), // 盘点状态
      adjustStatusMap: new Map([
        [1, '未调整'],
        [2, '全部调整'],
        [3, '无需调整'],
        [4, '调整中'],
        [5, '部分调整'],
      ]),
      columns: [
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '盘点单号',
          key: 'code',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '盘点类型',
          key: 'operatorType',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '创建人员',
          key: 'createUserName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点时间',
          key: 'operatorTime',
          minWidth: 130,
          tooltip: true,
        },
        {
          title: '盘点人员',
          key: 'operatorNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点状态',
          key: 'statusName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '调整状态',
          key: 'adjustStatusName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '操作',
          // fixed: 'right',
          minWidth: 110,
          render: (h, { row }) => {
            const btnList = [];
            const viewBtn = h('lk-tooltip', { // 查看按钮
              props: {
                content: '查看盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'inventoryCheck',
                      params: { id: row.id },
                    });
                  },
                },
              }, '查看'),
            ]);
            const logInBtn = h('lk-tooltip', { // 录入按钮
              props: {
                content: '录入盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'inventoryInput',
                      params: { id: row.id },
                    });
                  },
                },
              }, '录入'),
            ]);
            const adjustBtn = h('lk-tooltip', { // 调整按钮
              props: {
                content: '调整盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    const id = row.id;
                    this.$router.push({
                      name: 'inventoryAdjust',
                      params: { id },
                    });
                  },
                },
              }, '调整'),
            ]);
            const exportBtn = h('lk-tooltip', { // 导出按钮
              props: {
                content: '导出盘点结果',
                placement: 'top',
              },
            }, [
              h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    inventoryManage.exportAdjustSaleOrderList({ id: row.id })
                      .then((res) => {
                        utils.downLoadExcel(res, `应收盘点${row.code}-`);
                      })
                      .catch((err) => {
                        utils.handleError(err);
                      });
                  },
                },
              }, '导出'),
            ]);
            // 盘点未开始 1;初盘待完成 2;初盘已完成 3;复盘待完成 4;复盘已完成: 6;
            // 初盘待完成和复盘待完成展示录入按钮
            if ([2, 4].includes(row.status) && this.handlePermission('inventoryInput')) {
              btnList.push(logInBtn);
            }
            // 初盘已完成，复盘待完成，复盘已完成展示查看按钮
            if ([3, 4, 6].includes(row.status) && this.handlePermission('inventoryCheck')) {
              btnList.push(viewBtn);
            }
            // 初盘待完成，初盘已完成，复盘待完成，复盘已完成展示导出按钮
            if ([2, 3, 4, 6].includes(row.status) && this.handlePermission('inventoryExport')) {
              btnList.push(exportBtn);
            }
            // 复盘已完成展示调整按钮
            if ([6].includes(row.status) && row.adjustStatus === 1 && this.handlePermission('inventoryAdjust')) {
              btnList.push(adjustBtn);
            }
            return h('div', btnList);
          },
        },
      ],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.createTimeRange instanceof Array && this.params.createTimeRange.length) {
        this.params.startCreateTime = this.params.createTimeRange[0];
        this.params.endCreateTime = this.params.createTimeRange[1];
      }
      if (this.params.operatorTimeRange instanceof Array && this.params.operatorTimeRange.length) {
        this.params.startOperatorTime = this.params.operatorTimeRange[0];
        this.params.endOperatorTime = this.params.operatorTimeRange[1];
      }
      this.tableData = [];
      inventoryManage.receivableList(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            const { count, list } = res.data.data;
            this.count = count;
            list.forEach((item) => {
              if (item.operatorType) {
                item.operatorType = sharedData.operatorTypeList[item.operatorType - 1].name;
              }
              const result = {};
              utils.exchangeTable(item, result);
              result.createTime = utils.exchangeTime(result.createTime);
              result.operatorTime = utils.formatTime(result.operatorTime);
              result.statusStr = this.statusList.get(result.status);
              result.adjustStatusStr = this.adjustStatusMap.get(result.adjustStatus);
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
